import { useState, useMemo, useEffect, useCallback, useContext, useRef } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, MenuItem, Box, Button, Popover } from '@material-ui/core';
import { Undo } from '@material-ui/icons';
import moment from 'moment';
import _ from 'lodash';
import { connect, useSelector } from 'react-redux';
import rou from '../../../../router';
import {
  CheckIcon,
  UserIcon,
  CustomizeIcon,
  ExportIcon,
  MoreIcon,
  NotifyIcon,
  ResetIcon,
  WardIcon,
  SettingIcon,
  EditIcon,
  DateIcon,
} from '../../../../components/Icon';
import Dialog from '../../../../components/Dialog';
import { AutoCompleteRoster } from '../../../../components';
import { Checkbox } from '../Attendance/Setting';
import { i18n } from '../../../../language';
import { dutyAssignAPI } from '../../../../apis';
import { LoginPop } from '../../../../components/Login';
import useViewport from '../../../../utils/useViewport';
import { authNameE } from '../../../../utils/userFuncs';
import { useGetUserInfo } from '../../../../utils';
import { SetUnEdit } from '../../../../redux/actions';
import CreateChatroom from '../../components/TemplateEdit/CreateChatroom';
import { WarpSwitch } from '../../../../components/WarpSwitch';
import { DutyContext } from '../..';
import { KeyboardDatePicker } from '../../../../components/DatePicker';
import DatePicker from './DatePicker';
import DutyRosterDisplay from './DutyRosterDisplay';

const Staff = ({ name, check, id, rankCode, isValid, notifyStaff, setNotifyStaff, classes }) => {
  const handleChange = () => {
    if (isValid) {
      return;
    }
    const index = notifyStaff.findIndex((item) => {
      return item.id === id;
    });
    notifyStaff[index].check = !check;
    setNotifyStaff([...notifyStaff]);
  };
  return (
    <div className={classes.staffroot}>
      <Checkbox className={classes.checkbox} check={check} handleChange={handleChange} id={id} open={!isValid} />
      <div className={classes.checklabel}>{`${name}(${rankCode})`}</div>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  head: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'fixed',
    left: '6.25rem',
    right: 0,
    top: '4.375rem',
    height: '4.375rem',
    padding: '0 0 0 3.438rem',
    backgroundColor: theme.palette.font.white,
    boxShadow: '0 0 0.75rem #d2d7e0',
    zIndex: '99',
  },
  Left: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    letterSpacing: '0',
    color: theme.palette.font.sub,
    fongWeight: '500',
    marginRight: '1.25rem',
    whiteSpace: 'nowrap',
  },
  Right: {
    display: 'flex',
  },
  box: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '6.5rem',
    height: '4.375rem',
    borderLeft: '0.0625rem solid #e4e7eb',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: theme.palette.font.main,
    fontWeight: '600',
  },
  headBtn: {
    borderRadius: '0.625rem',
    padding: '0.85rem 1.25rem',
    textTransform: 'inherit',
    marginLeft: '0.938rem',
    backgroundColor: theme.palette.primary.main,
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: theme.palette.font.white,
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  headIcon: {
    fontSize: '1rem',
    marginRight: '0.5rem',
  },
  headWardIcon: {
    fontSize: '1.25rem',
    marginRight: '0.5rem',
  },
  dialog: {
    '& .MuiPaper-rounded': {
      marginTop: '-2.5rem',
      borderRadius: '0.9375rem',
      boxShadow: '0 -0.393rem 0.75rem rgba(0, 0, 0, 0.04)',
    },
  },
  dialogIcon: {
    fontSize: '1rem',
    color: '#5f9df6',
    float: 'right',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  btn: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  planlink: {
    borderRadius: '0.625rem',
    padding: '0.85rem 1rem',
    textTransform: 'inherit',
    marginLeft: '0.938rem',
    backgroundColor: theme.palette.primary.main,
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: theme.palette.font.white,
    display: 'flex',
    textDecoration: 'none',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  moreBtn: {
    widht: '1.5rem',
    height: '1.5rem',
    borderRadius: '0',
    padding: '0',
    margin: '0 3.438rem 0 1.25rem',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  moreIcon: {
    fontSize: '1.125rem',
    color: '#c0c6cb',
  },
  tagsItem: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    minWidth: '8.313rem',
    width: '100%',
    height: '3.75rem',
    whiteSpace: 'normal',
  },
  dropIcon: {
    color: theme.palette.font.main,
    marginRight: '1.125rem',
  },
  dropMenu: {
    '& .MuiMenu-paper': {
      boxShadow: '0 0 1rem 0 rgba(125, 134, 169, 0.2)',
    },
    '& .MuiList-padding': {
      padding: '0',
    },
    '& .MuiPopover-paper': {
      overflow: 'visible',
      '&::before': {
        position: 'absolute',
        top: '-0.688rem',
        left: '50%',
        marginLeft: '-0.688rem',
        content: '""',
        display: 'block',
        borderBottom: '0.688rem solid #fff',
        borderLeft: '0.688rem solid transparent',
        borderRight: '0.688rem solid transparent',
        width: '1.376rem',
        height: '0.688rem',
        zIndex: '10',
      },
      '&::after': {
        position: 'absolute',
        top: '-0.78rem',
        left: '50%',
        marginLeft: '-0.8rem',
        content: '""',
        display: 'block',
        borderBottom: '0.8rem solid rgba(0,0,0,0.03)',
        borderLeft: '0.8rem solid transparent',
        borderRight: '0.8rem solid transparent',
        width: '1.6rem',
        height: '0.8rem',
        zIndex: '0',
      },
    },
  },
  notifytext: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    lineHeight: '1.625rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    paddingBottom: '1.844rem',
    borderBottom: 'solid 1px #e4e7eb',
  },
  notifyBodyTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    lineHeight: '1.875rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    margin: '1.219rem 0 0.938rem',
  },
  notifyBody: {
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '& >div:nth-child(2n-1)': {
      marginRight: '1.875rem',
    },
  },
  staffroot: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1.25rem',
    flex: 'auto',
  },
  checkbox: {
    padding: '0',
    '&.MuiCheckbox-colorSecondary.Mui-checked': {
      color: theme.palette.status.green,
    },
    '&.MuiCheckbox-root': {
      color: '#c0c6cb',
    },
  },
  checklabel: {
    display: 'flex',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    padding: '0.688rem 0 0.688rem 1.25rem',
    border: 'solid 0.0625rem #e6e7e8',
    borderRadius: '0.625rem',
    width: '16.625rem',
    marginLeft: '1.25rem',
  },
  resetBody: {
    color: theme.palette.font.main,
    fontSize: '1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    lineHeight: '1.875rem',
  },
  settingIcon: {
    fontSize: '1.125rem',
    color: '#2E4469',
    marginRight: '1.13rem',
  },
  AZIcon: {
    width: '1.45rem',
    fontSize: '1.125rem',
    color: '#2E4469',
    marginRight: '0.95rem',
  },
  layerIcon: {
    fontSize: '1.125rem',
    width: '0.6rem',
    color: '#2E4469',
    marginRight: '1.4rem',
    marginLeft: '0.375rem',
  },
  dialogBodyDatePicker: {
    '& .MuiInputBase-root': {
      borderRadius: '0.625rem',
      border: '0.0625rem solid #E4E7EB',
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: theme.palette.font.main,
      fontWeight: 'normal',
      width: '11.938rem',
      height: '3rem',
    },
    '& .MuiButtonBase-root': {
      borderRadius: '0',
      padding: '0',
      '&:hover': {
        backgroundColor: theme.palette.font.white,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      display: 'none',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '0.75rem',
    },
  },
  Picon: {
    color: '#538fff',
  },
}));

function Header({
  isLogin,
  getExportAPI,
  getNotifyStaffAPI,
  notifyList,
  pushNotifyStaffAPI,
  wardId,
  history,
  roleMap,
  rouList,
  notifyOpen,
  setNotifyOpen,
  dutyInfo,
  setRosterId,
  editFlag,
  setUnEdit,
  staffsList,
  getResetDutyAPI,
  publishCtrl,
  setAlertInfo,
  setDutyInfo,
  initDutyInfo,
  appendNoteList,
  getFootNoteAPI,
  enableSmartComm,
  hasDutyChat
}) {
  const dutyDateInfo = JSON.parse(sessionStorage.getItem('dutyInfo'));
  const classes = useStyles();
  const [selectDate, handleDateChange] = useState(dutyDateInfo ? dutyDateInfo.date : moment());
  const [selectRoster, setSelectRoster] = useState(dutyDateInfo ? dutyDateInfo.index : 0);
  const [dropdown, setDropdown] = useState(null);
  const dropdownopen = Boolean(dropdown);
  const [notifyStaff, setNotifyStaff] = useState([]);
  const [roster, setRoster] = useState([]);
  const [open, setOpen] = useState(false);
  const { width } = useViewport();
  const breakPoint = {
    saveBreakpoint: 1340,
    pianningBreakpoint: 1220,
    customizeBreakpoint: 1000,
    attendanceBreakpoint: 860,
  };
  const userInfo = useGetUserInfo();
  const [resetOpen, setResetOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [editType, setEditType] = useState(false);
  const [rosterDisplay, setRosterDisplay] = useState(false);
  const [openSetupChatroom, setOpenSetupChatroom] = useState(false);
  const { isSort, setPublishInfo } = useContext(DutyContext);
  const [rosterMaxWidth, setRosterMaxWidth] = useState('11rem');
  const [dialogopen, setDialogopen] = useState(false);
  const [previousMessage, setPreviousMessage] = useState('');
  const [previousConfirmOpen, setPreviousConfirmOpen] = useState(false);
  const [saveNodeConfirmOpen, setSaveNodeConfirmOpen] = useState(false);
  const [saveNodeMessage, setSaveNodeMessage] = useState('');
  const dutyInfoContent = useRef({});
  const footNoteInfoContent = useRef({});
  const loginInfo = useSelector((state) => state.loginInfo);
  const [selectCopyDate, setSelectCopyDate] = useState(null);
  const [copyConfirmDisabled, setCopyConfirmDisabled] = useState(true);
  
  let staffList = _.map(
    notifyStaff.filter((item) => {
      return item.check;
    }),
    (item) => {
      return item.id;
    }
  );

  // getRosterAPI
  const getRosterAPI = async ({ time }) => {
    try {
      const { result } = await dutyAssignAPI.getTemplateRoster({
        wardId: wardId,
        timeStart: time,
        timeEnd: time,
      });
      setRoster([...result]);
    } catch (error) {
      console.log('-----Update Duty error----->', error);
    }
  };

  useEffect(() => {
    setRoster([]);
    if (moment(selectDate).isBetween(moment('1976-01-01', 'yyyy-MM-DD'), moment('9999-12-31', 'yyyy-MM-DD'))) {
      (async () => {
        await getRosterAPI({ time: moment(selectDate).format('DD-MM-YYYY') });
      })();

      sessionStorage.setItem('dutyInfo', JSON.stringify({ date: selectDate, id: -1, index: 0 }));
    }
  }, [selectDate, rouList]);

  useEffect(() => {
    if (rosterList.length > 0 && rosterList[selectRoster] && rosterList[selectRoster].id) {
      sessionStorage.setItem(
        'dutyInfo',
        JSON.stringify({ date: selectDate, id: rosterList[selectRoster].id, index: selectRoster })
      );
      setRosterId(rosterList[selectRoster].id);
      return;
    }
    return () => {
      setRosterId(-1);
    };
  }, [selectRoster, roster]);

  const getRosterMaxWidth = (list) => {
    let width = 0;
    list.forEach((roster) => {
      let showText = roster.text;
      if (roster.text.length > 30) {
        showText = roster.text.slice(0, 30);
      }
      const tempElement = document.createElement('span');
      tempElement.style.fontSize = '1rem';
      tempElement.style.paddingLeft = '1rem';
      tempElement.style.paddingRight = '1rem';
      tempElement.textContent = showText;
      document.body.appendChild(tempElement);
      if (tempElement.getBoundingClientRect().width > width) {
        width = tempElement.getBoundingClientRect().width;
      }
      document.body.removeChild(tempElement);
    });
    setRosterMaxWidth(`${(width + 16) / 14 > 11 ? (width + 16) / 14 : 11}rem`);
  };

  const rosterList = useMemo(() => {
    let list = [];

    if (Array.isArray(roster) && roster.length > 0) {
      list = _.map(_.orderBy(roster, ['rosterOrder'], ['asc']), (item, index) => {
        return {
          id: item.dutyTemplateRosterId,
          value: index,
          text: item.rosterCode,
          rosterOrder: item.rosterOrder,
        };
      });
    }

    if (Array.isArray(roster) && roster.length === 0) {
      list = [];
    }
    getRosterMaxWidth(list);
    return list;
  }, [roster]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelectDate = (value) => {
    if (editFlag) {
      setConfirmOpen(true);
      setEditType({ type: 'date', value });
      return;
    }
    setSelectRoster(0);
    handleDateChange(value);
  };

  const handleSelectRoster = (value) => {
    if (editFlag) {
      setConfirmOpen(true);
      setEditType({ type: 'roster', value });
      return;
    }
    setSelectRoster(value);
  };

  const notify = useMemo(() => {
    let list = [];

    if (Array.isArray(notifyList) && notifyList.length > 0) {
      list = _.map(staffsList, (item) => {
        if (item.corpId) {
          const temp = _.find(notifyList, (staff) => {
            return staff.corpId === item.corpId;
          });
          return {
            id: temp?.corpId ?? item.corpId,
            name: temp?.staffName ?? item.name,
            check: Boolean(temp),
            isValid: temp?.isValid === 0,
            cubicles: temp?.cubicles ?? null,
            rankCode: temp?.rankCode ?? item.rankCode ?? null,
            type: temp?.type ?? 4,
            order: temp?.isPush ?? -1,
          };
        }
        return {
          id: item.corpId,
          name: item.name,
          check: false,
          isValid: true,
          cubicles: null,
          rankCode: item.rankCode,
          order: item.tempId ? -3 : -2,
        };
      });
      setNotifyStaff([...list]);
    }

    return _.orderBy(list, ['order'], ['desc']);
  }, [notifyList]);

  function buttonContrl() {
    return isLogin ? (
      <div className={classes.Left}>
        {width > breakPoint.customizeBreakpoint && roleMap[authNameE.dutyAssign_Custumize] && (
          <Link className={classes.planlink} to={rou.PlannerRou.path} id="DutyAssign-Link-adm">
            <CustomizeIcon className={classes.headIcon} />
            {i18n.t('DUTYASSIGN_CUSTOMIZE')}
          </Link>
        )}
        {width > breakPoint.pianningBreakpoint && roleMap[authNameE.dutyAssign_Reileving_Planning] && (
          <Link className={classes.planlink} to={rou.RelievingPlanningRou.path} id="DutyAssign-Link-adn">
            <WardIcon style={{ fontSize: '1.125rem', color: '#ffffff', marginRight: '0.75rem' }} />
            {i18n.t('DUTYASSIGN_RELIEVING')}
          </Link>
        )}
      </div>
    ) : (
      <div className={classes.Left}>
        {width > breakPoint.customizeBreakpoint && (
          <Button id="6" className={classes.headBtn} onClick={handleClickOpen}>
            <UserIcon className={classes.headIcon} style={{ fontSize: '1.25rem' }} />
            {i18n.t('DUTYASSIGN_ICMODE')}
          </Button>
        )}
        {width > breakPoint.pianningBreakpoint && roleMap[authNameE.dutyAssign_Reileving_Planning] && (
          <Link id="7" className={classes.planlink} to={rou.RelievingPlanningRou.path}>
            <WardIcon style={{ fontSize: '1.125rem', color: '#ffffff', marginRight: '0.75rem' }} />
            {i18n.t('DUTYASSIGN_RELIEVING')}
          </Link>
        )}
      </div>
    );
  }

  const handleLeaveCancel = () => {
    setConfirmOpen(false);
  };

  const updateStaffSorts = async (e) => {
    try {
      setDropdown(null);
      setPublishInfo((prePublishInfo) => ({
        ...prePublishInfo,
        isSort: e.target.checked ? 1 : 0,
      }));
    } catch (error) {}
  };

  const handleLeaveConfirm = useCallback(() => {
    setUnEdit();
    setConfirmOpen(false);
    if (editType) {
      if (editType.type === 'date') {
        setSelectRoster(0);
        handleDateChange(editType.value);
        setEditType(false);
        return;
      } else if (editType.type === 'roster') {
        setSelectRoster(editType.value);
        setEditType(false);
        return;
      }
    }
  }, [editType]);

  // create notes
  const createNotes = async (notes) => {
    console.log('notes === ', notes);
    try {
      Promise.all(
        notes.reverse().map((item, itemIndex) => {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve(
                dutyAssignAPI.postCreateDaFootNote({
                  templateRosterId: dutyDateInfo?.id,
                  footnoteName: item?.footnoteName,
                  footnoteDesc: null,
                })
              );
            }, itemIndex * 80);
          });
        })
      ).then(async (results) => {
        console.log('save notes result === ', results);
        await getFootNoteAPI();
        setAlertInfo({
          open: true,
          text: i18n.t('DUTYASSIGN_ROSTER_COPY_ASSIGNMENTS_SUCCESS'),
          type: 'success',
        });
      });
    } catch (error) {
      console.log('-----Create Note error----->', error);
    }
  };

  const handleCopyRequest = (date) => {
    const options = {
      templateRosterId: dutyDateInfo?.id,
      userId: loginInfo?.userId,
      prevTime: date,
    };
    dutyAssignAPI.getResetPrevDuty(options).then((res) => {
      const { result } = res;
      const sourceStartTimeFormated = moment(result.sourceStartTime)?.format('DD-MM-YYYY');
      switch (result.sourceType) {
        case 'none':
          setPreviousMessage(i18n.t('DUTYASSIGN_ROSTER_COPY_NO_ROSTER'));
          setCopyConfirmDisabled(true);
          dutyInfoContent.current = null;
          break;
        case 'template':
          setPreviousMessage(i18n.t('DUTYASSIGN_ROSTER_COPY_NO_DATA', { value: sourceStartTimeFormated }));
          setCopyConfirmDisabled(true);
          dutyInfoContent.current = null;
          break;
        case 'draft':
        case 'publish':
          dutyInfoContent.current = result.sourceContent;
          footNoteInfoContent.current = _.orderBy(result.sourceFootNotes, ['order'], ['asc']);
          setPreviousMessage(i18n.t('DUTYASSIGN_ROSTER_COPY_ROSTER_DETAIL', { value: sourceStartTimeFormated }));
          setCopyConfirmDisabled(false);
          break;
        default:
          break;
      }
    });
  };

  return (
    <div className={classes.head}>
      <div className={classes.Left}>
        <div className={classes.title}>{i18n.t('DUTYASSIGN_FILTERBY')}</div>
        <DatePicker handleSelectDate={handleSelectDate} id="DutyAssign-DatePicker-adp" selectDate={selectDate} />
        <AutoCompleteRoster
          id="4"
          itemList={rosterList}
          height="2.813rem"
          width={rosterMaxWidth}
          style={{ flex: 1 }}
          value={selectRoster}
          placeholder={i18n.t('DUTYASSIGN_SELECT_ROSTER')}
          onChange={handleSelectRoster}
          className="duty-assign-header-roster-list"
        />
      </div>
      <Box className={classes.Left}>
        {dutyDateInfo?.id > 0 && (
          <Box padding="0 1rem" display="flex" alignItems="center">
            <WarpSwitch checked={isSort === 1 ? true : false} onChange={updateStaffSorts} />
            <Box
              marginLeft="0.6rem"
              fontSize="0.875rem"
              color={isSort === 1 ? '#538fff' : '#7D86A9'}
              fontFamily="NotoSans-Medium"
            >
              {i18n.t('DUTYASSIGN_CUS_ORDER')}
            </Box>
          </Box>
        )}

        {width > breakPoint.attendanceBreakpoint && (
          <Link id="5" className={classes.planlink} style={{ backgroundColor: '#28d2ab' }} to={rou.attendanceRou.path}>
            <CheckIcon className={classes.headIcon} />
            {i18n.t('DUTYASSIGN_ATTENDANCE')}
          </Link>
        )}
        {buttonContrl()}
        <IconButton
          id="8"
          className={classes.moreBtn}
          onClick={(event) => {
            setDropdown(event.currentTarget);
          }}
        >
          <MoreIcon className={classes.moreIcon} />
        </IconButton>
        {open && <LoginPop closehandle={handleClose} submitHandle={handleClose} id="DutyAssign-LoginPop-adq" />}
        {/* 弹出 */}
        <Popover
          anchorEl={dropdown}
          open={dropdownopen}
          id="DutyAssign-Menu-adr"
          onClose={() => {
            setDropdown(null);
          }}
          keepMounted
          className={classes.dropMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          {isLogin ? (
            <div>
              {width <= breakPoint.attendanceBreakpoint && (
                <MenuItem
                  className={classes.tagsItem}
                  onClick={() => {
                    history.push(rou.attendanceRou.path);
                    setDropdown(null);
                  }}
                  id="DutyAssign-MenuItem-ads"
                  style={{ borderBottom: 'solid 1px #e4e7eb', width: '12rem' }}
                >
                  <CustomizeIcon className={classes.dropIcon} style={{ fontSize: '1.125rem' }} />
                  {i18n.t('DUTYASSIGN_ATTENDANCE')}
                </MenuItem>
              )}
              {width <= breakPoint.customizeBreakpoint && roleMap[authNameE.dutyAssign_Custumize] && (
                <MenuItem
                  className={classes.tagsItem}
                  onClick={() => {
                    history.push(rou.PlannerRou.path);
                    setDropdown(null);
                  }}
                  id="DutyAssign-MenuItem-adt"
                  style={{ borderBottom: 'solid 1px #e4e7eb', width: '12rem' }}
                >
                  <CustomizeIcon className={classes.dropIcon} style={{ fontSize: '1.125rem' }} />
                  {i18n.t('DUTYASSIGN_CUSTOMIZE')}
                </MenuItem>
              )}
              {width <= breakPoint.pianningBreakpoint && roleMap[authNameE.dutyAssign_Reileving_Planning] && (
                <MenuItem
                  className={classes.tagsItem}
                  onClick={() => {
                    history.push(rou.RelievingPlanningRou.path);
                    setDropdown(null);
                  }}
                  id="DutyAssign-MenuItem-adu"
                  style={{
                    borderBottom: 'solid 1px #e4e7eb',
                    width: width <= breakPoint.customizeBreakpoint ? '12rem' : '9.5rem',
                  }}
                >
                  <WardIcon className={classes.dropIcon} style={{ fontSize: '1.125rem' }} />
                  {i18n.t('DUTYASSIGN_RELIEVING')}
                </MenuItem>
              )}
              <MenuItem
                id="9"
                className={classes.tagsItem}
                onClick={() => {
                  if (dutyDateInfo?.id === -1) {
                    return;
                  }
                  getExportAPI();
                  setDropdown(null);
                }}
              >
                <ExportIcon className={classes.dropIcon} style={{ fontSize: '1.125rem' }} />
                {i18n.t('DUTYASSIGN_EXPORT')}
              </MenuItem>
              {roleMap[authNameE.dutyAssign_Update_Save_Publish_Notify] && (
                <MenuItem
                  className={classes.tagsItem}
                  onClick={() => {
                    if (dutyDateInfo?.id === -1) {
                      return;
                    }
                    getNotifyStaffAPI();
                    setDropdown(null);
                  }}
                  id="DutyAssign-MenuItem-adw"
                  style={{ borderTop: 'solid 1px #e4e7eb', borderBottom: 'solid 1px #e4e7eb' }}
                >
                  <NotifyIcon className={classes.dropIcon} style={{ fontSize: '1.1375rem' }} />
                  {i18n.t('DUTYASSIGN_NOTIFY')}
                </MenuItem>
              )}
              <MenuItem
                className={classes.tagsItem}
                onClick={() => {
                  setDropdown(null);
                  if (dutyDateInfo?.id === -1 || dutyInfo === null || JSON.stringify(dutyInfo) === '{}') {
                    return;
                  }
                  dutyAssignAPI
                    .getResetPrevDuty({
                      templateRosterId: dutyDateInfo?.id,
                      userId: loginInfo?.userId,
                    })
                    .then((res) => {
                      const { result } = res;
                      const sourceStartTimeFormated = moment(result.sourceStartTime)?.format('DD-MM-YYYY');
                      switch (result.sourceType) {
                        case 'none':
                          setPreviousMessage(i18n.t('DUTYASSIGN_ROSTER_COPY_NO_ROSTER'));
                          setDialogopen(true);
                          break;
                        case 'template':
                          setPreviousMessage(
                            i18n.t('DUTYASSIGN_ROSTER_COPY_NO_DATA', { value: sourceStartTimeFormated })
                          );
                          setDialogopen(true);
                          break;
                        case 'draft':
                        case 'publish':
                          dutyInfoContent.current = result.sourceContent;
                          footNoteInfoContent.current = _.orderBy(result.sourceFootNotes, ['order'], ['asc']);
                          setCopyConfirmDisabled(false);
                          setPreviousMessage(
                            i18n.t('DUTYASSIGN_ROSTER_COPY_ROSTER_DETAIL', { value: sourceStartTimeFormated })
                          );
                          setSelectCopyDate(result.sourceStartTime);
                          setPreviousConfirmOpen(true);
                          break;
                        default:
                          break;
                      }
                    });
                }}
                id="DutyAssign-MenuItem-adx"
                style={{ borderBottom: 'solid 1px #e4e7eb' }}
              >
                <Undo className={classes.dropIcon} style={{ fontSize: '1.125rem' }} />
                {i18n.t('DUTYASSIGN_ROSTER_COPY_ASSIGNMENTS')}
              </MenuItem>
              {roleMap[authNameE.dutyAssign_Update_Save_Publish_Notify] && (
                <MenuItem
                  className={classes.tagsItem}
                  onClick={() => {
                    if (dutyDateInfo?.id === -1 || dutyInfo === null || JSON.stringify(dutyInfo) === '{}') {
                      return;
                    }
                    setResetOpen(true);
                  }}
                  id="DutyAssign-MenuItem-adx"
                  style={{ borderBottom: 'solid 1px #e4e7eb' }}
                >
                  <ResetIcon className={classes.dropIcon} style={{ fontSize: '1.125rem' }} />
                  {i18n.t('DUTYASSIGN_RESET')}
                </MenuItem>
              )}
              {dutyDateInfo?.id > 0 && publishCtrl && (
                <MenuItem
                  id="DutyAssign-MenuItem-ady"
                  className={classes.tagsItem}
                  onClick={() => {
                    setRosterDisplay(true);
                    setDropdown(null);
                  }}
                  style={{ borderBottom: 'solid 1px #e4e7eb' }}
                >
                  <SettingIcon className={classes.settingIcon} />
                  {i18n.t('DUTY_ASSIGN_ROSTER_SETUP')}
                </MenuItem>
              )}
              {(enableSmartComm||roleMap[authNameE.setting_view_Ward_Chatroom_Setup]) && (
                <MenuItem
                  id="DutyAssign-MenuItem-setupChatroom"
                  className={classes.tagsItem}
                  onClick={() => {
                    setDropdown(null);
                    setOpenSetupChatroom(true);
                  }}
                >
                  <EditIcon className={classes.dropIcon} style={{ fontSize: '1.125rem' }} />
                  {i18n.t('DUTYASSIGN_CREATE_CHATROOM_MENU')}
                </MenuItem>
              )}
            </div>
          ) : (
            <div>
              {width <= breakPoint.attendanceBreakpoint && (
                <MenuItem
                  className={classes.tagsItem}
                  onClick={() => {
                    history.push(rou.attendanceRou.path);
                    setDropdown(null);
                  }}
                  id="DutyAssign-MenuItem-ady"
                  style={{ borderBottom: 'solid 1px #e4e7eb', width: '9.5rem' }}
                >
                  <CustomizeIcon className={classes.dropIcon} style={{ fontSize: '1.125rem' }} />
                  {i18n.t('DUTYASSIGN_ATTENDANCE')}
                </MenuItem>
              )}
              {width <= breakPoint.customizeBreakpoint && (
                <MenuItem
                  className={classes.tagsItem}
                  onClick={() => {
                    handleClickOpen();
                    setDropdown(null);
                  }}
                  id="DutyAssign-MenuItem-adz"
                  style={{ borderBottom: 'solid 1px #e4e7eb' }}
                >
                  <UserIcon className={classes.dropIcon} style={{ fontSize: '1.125rem' }} />
                  {i18n.t('DUTYASSIGN_ICMODE')}
                </MenuItem>
              )}
              {width <= breakPoint.pianningBreakpoint && roleMap[authNameE.dutyAssign_Reileving_Planning] && (
                <MenuItem
                  className={classes.tagsItem}
                  onClick={() => {
                    history.push(rou.RelievingPlanningRou.path);
                    setDropdown(null);
                  }}
                  id="DutyAssign-MenuItem-aea"
                  style={{ borderBottom: 'solid 1px #e4e7eb' }}
                >
                  <WardIcon className={classes.dropIcon} style={{ fontSize: '1.125rem' }} />
                  {i18n.t('DUTYASSIGN_RELIEVING')}
                </MenuItem>
              )}
              <MenuItem
                id="9"
                className={classes.tagsItem}
                onClick={() => {
                  if (dutyDateInfo?.id === -1) {
                    return;
                  }
                  getExportAPI();
                  setDropdown(null);
                }}
              >
                <ExportIcon className={classes.dropIcon} style={{ fontSize: '1.125rem' }} />
                {i18n.t('DUTYASSIGN_EXPORT')}
              </MenuItem>
              {dutyDateInfo?.id > 0 && publishCtrl && (
                <MenuItem
                  id="10"
                  className={classes.tagsItem}
                  onClick={() => {
                    setRosterDisplay(true);
                    setDropdown(null);
                  }}
                >
                  <SettingIcon className={classes.settingIcon} />
                  {i18n.t('DUTY_ASSIGN_ROSTER_SETUP')}
                </MenuItem>
              )}
            </div>
          )}
        </Popover>
        {dialogopen ? (
          <Dialog
            open={dialogopen}
            id="DutyAssign-DiaLog-aik-delete"
            cancel={i18n.t('EQUIPMENT_CONFIRM_OK')}
            readOnly={true}
            title={i18n.t('DUTYASSIGN_ROSTER_COPY_INFO')}
            handleClose={() => {
              setDialogopen(false);
            }}
            handleCancel={() => {
              setDialogopen(false);
            }}
          >
            <div className={classes.publishBody}>{previousMessage} </div>
          </Dialog>
        ) : null}
        {previousConfirmOpen ? (
          <Dialog
            open={previousConfirmOpen}
            id="DutyAssign-DiaLog-aik-number"
            confirm={i18n.t('DUTYASSIGN_CONFIRM')}
            cancel={i18n.t('DUTYASSIGN_CANCEL')}
            title={i18n.t('DUTYASSIGN_ROSTER_SELECT_PREVIOU_DATE')}
            handleCancel={() => {
              setPreviousConfirmOpen(false);
            }}
            handleClose={() => {
              setPreviousConfirmOpen(false);
            }}
            handleConfirm={() => {
              setPreviousConfirmOpen(false);
              if (dutyInfoContent.current) {
                setDutyInfo(initDutyInfo(dutyInfoContent.current));
                if (footNoteInfoContent.current.length > 0) {
                  setSaveNodeMessage(
                    i18n.t('DUTYASSIGN_ROSTER_COPY_ROSTER_MESSAGE', { value: footNoteInfoContent.current?.length })
                  );
                  setSaveNodeConfirmOpen(true);
                }
              } else {
                setAlertInfo({ open: true, text: i18n.t('DUTYASSIGN_ROSTER_COPY_ASSIGNMENTS_FAILD'), type: 'warning' });
              }
            }}
            disabled={copyConfirmDisabled}
          >
            <div style={{ marginBottom: '1rem' }}>
              <KeyboardDatePicker
                className={classes.dialogBodyDatePicker}
                keyboardIcon={<DateIcon className={classes.Picon} />}
                id="DutyAssign-KeyboardDatePicker-afc"
                variant="dialog"
                format="DD-MM-yyyy"
                inputVariant="outlined"
                disableOpenPicker={true}
                InputAdornmentProps={{ position: 'end' }}
                disabled={false}
                value={selectCopyDate}
                maxDate={moment(selectDate).subtract({ days: 1 })}
                minDate={moment('1976-01-01', 'YYYY-MM-DD')}
                onChange={(value) => {
                  if (value?.isValid() && value.valueOf() > 0) {
                    setSelectCopyDate(value);
                    handleCopyRequest(value.valueOf());
                  } else {
                    dutyInfoContent.current = null;
                    setCopyConfirmDisabled(true);
                    setPreviousMessage(i18n.t('DUTYASSIGN_ROSTER_COPY_NO_ROSTER'));
                  }
                }}
              />
            </div>

            <div className={classes.publishBody}>{previousMessage}</div>
          </Dialog>
        ) : null}
        {saveNodeConfirmOpen ? (
          <Dialog
            open={saveNodeConfirmOpen}
            id="DutyAssign-DiaLog-aik-number"
            confirm={i18n.t('DUTYASSIGN_CONFIRM')}
            cancel={i18n.t('DUTYASSIGN_CANCEL')}
            title={i18n.t('DUTYASSIGN_ROSTER_COPY_INFO')}
            handleCancel={() => {
              setSaveNodeConfirmOpen(false);
              if (footNoteInfoContent.current.length > 0) {
                appendNoteList(footNoteInfoContent.current);
              }
              setAlertInfo({
                open: true,
                text: i18n.t('DUTYASSIGN_ROSTER_COPY_ASSIGNMENTS_SUCCESS'),
                type: 'success',
              });
            }}
            handleClose={() => {
              setSaveNodeConfirmOpen(false);
              if (footNoteInfoContent.current.length > 0) {
                appendNoteList(footNoteInfoContent.current);
              }
              setAlertInfo({
                open: true,
                text: i18n.t('DUTYASSIGN_ROSTER_COPY_ASSIGNMENTS_SUCCESS'),
                type: 'success',
              });
            }}
            handleConfirm={() => {
              setSaveNodeConfirmOpen(false);
              if (footNoteInfoContent.current.length > 0) {
                createNotes(footNoteInfoContent.current);
              }
            }}
          >
            <div className={classes.publishBody}>{saveNodeMessage}</div>
          </Dialog>
        ) : null}
        <Dialog
          open={notifyOpen}
          id="DutyAssign-Dialog-aeb"
          handleOnClose={() => setNotifyOpen(false)}
          handleClose={() => setNotifyOpen(false)}
          handleCancel={() => setNotifyOpen(false)}
          handleConfirm={() => {
            if (staffList.length === 0) {
              return;
            }
            let corpInfos = [];

            corpInfos = _.map(
              notify.filter((item) => {
                return item.check;
              }),
              (item) => {
                return {
                  corpId: item.id,
                  staffName: item.name,
                  type: item.type ?? null,
                  cublics: _.map(item.cubicles, (cubicle) => {
                    return cubicle.name;
                  }),
                };
              }
            );

            pushNotifyStaffAPI({
              dutyDate: moment(selectDate).format('yyyy-MM-DD'),
              wardName: userInfo.wardName,
              corpInfos,
              hospitalCode: userInfo.hospCode,
              wardId: userInfo.wardId,
            });
            setNotifyOpen(false);
          }}
          title={i18n.t('DUTYASSIGN_NOTIFY_TITLE')}
          cancel={i18n.t('DUTYASSIGN_CANCEL')}
          confirm={i18n.t('DUTYASSIGN_SEND')}
          dialogfootStyle={{ padding: '1rem 0', borderTop: 'solid 1px #e4e7eb', margin: '0' }}
          dialogRootStyle={{ paddingBottom: '0' }}
          confirmStyle={{ opacity: staffList.length === 0 ? 0.2 : 1 }}
          cancelID="DutyAssign-Dialog-agw-cancel"
          confirmID="DutyAssign-Dialog-agw-confirm"
          closeID="DutyAssign-Dialog-agw-close"
        >
          <div className={classes.notifytext}>{i18n.t('DUTYASSIGN_NOTIFY_BODY')}</div>
          <div className={classes.notifyBodyTitle}>{i18n.t('DUTYASSIGN_NOTIFY_LIST_TITLE')}</div>
          <div className={classes.notifyBody}>
            {notify.map((item) => (
              <Staff
                name={item.name}
                check={item.check}
                id={item.id}
                key={item.id}
                rankCode={item.rankCode}
                isValid={item.isValid}
                notifyStaff={notifyStaff}
                setNotifyStaff={setNotifyStaff}
                classes={classes}
              />
            ))}
          </div>
        </Dialog>
        <Dialog
          open={resetOpen}
          id="DutyAssign-Dialog-aec"
          cancel={i18n.t('DUTYASSIGN_CANCEL')}
          confirm={i18n.t('DUTYASSIGN_CONFIRM')}
          title={i18n.t('DUTYASSIGN_RESET_DIALOG_TITLE')}
          handleCancel={() => setResetOpen(false)}
          handleClose={() => setResetOpen(false)}
          handleConfirm={async () => {
            if (dutyInfo === null || JSON.stringify(dutyInfo) === '{}') {
              return;
            }
            await getResetDutyAPI();
            setResetOpen(false);
            setDropdown(null);
          }}
          cancelID="DutyAssign-Dialog-agw-cancel"
          confirmID="DutyAssign-Dialog-agw-confirm"
          closeID="DutyAssign-Dialog-agw-close"
        >
          <div className={classes.resetBody}>{i18n.t('DUTYASSIGN_RESET_DIALOG_BODY')}</div>
        </Dialog>
        <Dialog
          open={confirmOpen}
          id="DutyAssign-Dialog-aed"
          handleClose={handleLeaveCancel}
          handleCancel={handleLeaveCancel}
          title={i18n.t('DUTYASSIGN_NOT_SAVE_TITLE')}
          cancel={i18n.t('DUTYASSIGN_CANCEL')}
          confirm={i18n.t('DUTYASSIGN_CONFIRM')}
          handleConfirm={handleLeaveConfirm}
          cancelID="DutyAssign-Dialog-agw-cancel"
          confirmID="DutyAssign-Dialog-agw-confirm"
          closeID="DutyAssign-Dialog-agw-close"
        >
          <div
            style={{
              color: '#2e4469',
              fontSize: '1.25rem',
              fontFamily: 'NotoSans-Medium',
              fontWeight: 500,
              lineHeight: '1.875rem',
            }}
          >
            {i18n.t('DUTYASSIGN_NOT_SAVE_BODY')}
          </div>
        </Dialog>
        {rosterDisplay && <DutyRosterDisplay handleClose={() => setRosterDisplay(false)} hasDutyChatValue={hasDutyChat} />}
        {openSetupChatroom && (
          <CreateChatroom
            closePop={() => {
              setOpenSetupChatroom(false);
            }}
            open={openSetupChatroom}
            title={i18n.t('DUTYASSIGN_CREATE_CHATROOM_TITLE')}
            setAlertInfo={setAlertInfo}
          />
        )}
      </Box>
    </div>
  );
}

const mapStateToProps = (state) => ({
  roleMap: state.roleMap,
  rouList: state.rouList,
  editFlag: state.dutyEditFlag,
});

const mapDispatchToProps = (dispatch) => ({
  setUnEdit: () => {
    dispatch(SetUnEdit());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
